const SESSION_KEY = "mhdc_admin_session_v1";

const PASSCODES = new Map([
  ["MhDC2026@Chicago", { role: "admin" }],
  ["DCMh2026@Chicago", { role: "admin" }],
]);

export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (!parsed.role) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function loginWithPasscode(passcode) {
  const normalized = String(passcode || "").trim();
  const match = PASSCODES.get(normalized);
  if (!match) return null;

  const session = {
    role: match.role,
    loggedInAt: new Date().toISOString(),
  };

  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
  } catch {
    // ignore storage errors
  }

  return session;
}

export function logoutAdmin() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore
  }
}

